// Prototype. Do not instantiate, but extend this class in order to create local stores for custom column cells.

import { ICellRendererParams } from 'ag-grid-community';
import { ComponentStore } from '@ngrx/component-store';
import { Injectable } from '@angular/core';

export interface AgCellState {
  cellValue: string | string[],
  params: ICellRendererParams
}

@Injectable()
export abstract class AgCellLocalStoreService<T extends AgCellState> extends ComponentStore<T> {
  protected constructor(defaultState?: T) {
    super(defaultState);
  }

  readonly cellValue$ = this.select(state => state.cellValue);
  readonly params$ = this.select(state => state.params);

  // UPDATERS
  readonly updateCellValue = this.updater((state, cellValue: string | string[]): T => ({
    ...state, cellValue,
  }));

  readonly updateParams = this.updater((state, params: ICellRendererParams): T => ({
    ...state, params,
  }));
}
